import * as React from 'react';
import { SVGProps } from 'react';

const FileIconTiffSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 18H9v9.667L12 25l6 5 4-3 3 2.25V18H9.5ZM9 31.5v-2.167l3-2.81 5.906 4.797L22 28.25l3 2.25V32H9v-.5Zm-1-13V33h18V17H8v1.5Zm10 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
      fill="#fff"
    />
    <path
      d="M15 6V5h-1v1h1ZM13 7v1h1v3h-1v1h3v-1h-1V7h-2ZM19.09 6.09a.374.374 0 0 1 .26-.09h1.15V5h-1.46c-.307 0-.557.1-.75.3-.193.193-.29.46-.29.8V7h-1v1h1v3h-1v1h3v-1h-1V8h1V7h-1v-.7c0-.087.03-.157.09-.21ZM23.09 6.09a.374.374 0 0 1 .26-.09h1.15V5h-1.46c-.307 0-.557.1-.75.3-.193.193-.29.46-.29.8V7h-1v1h1v3h-1v1h3v-1h-1V8h1V7h-1v-.7c0-.087.03-.157.09-.21ZM11.05 12c-.34 0-.6-.11-.78-.33-.18-.22-.27-.51-.27-.87V8H9V7h1V6h1v1h1v1h-1v2.6c0 .147.037.25.11.31.073.06.187.09.34.09H12v1h-.95Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconTiffSizeM;
